import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './express.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Express } from "model/system/express";

export interface ExpressDetailsProps extends DetailsStateAndDispatchProps<Express>,
  RouteComponentProps, StateProps, DispatchProps {
}

const ExpressDetails: FC<ExpressDetailsProps> = (props: any) => {
  return (
    <DetailsPage<Express>
      title='快递公司详情'
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Express>
        columns={props.columns}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ express }: RootState) => ({
  entity: express.entity,
});

const mapDispatchToProps = {
  getEntity
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ExpressDetails);
